import { registerComponent } from '@gig/magic-common';
import KeycloakTOtpComponent from './keycloak-totp.vue.js';

var KeycloakTOtp = registerComponent(KeycloakTOtpComponent);

export { KeycloakTOtp };
